import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';
import { deleteRoom, fetchRoomsByStays } from '../../../features/admin/roomSlice';
import { useTranslation } from 'react-i18next';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import ConfirmDeleteModal from './ConfirmDeleteModal';
import Cookies from 'js-cookie';

const RoomList = ({ rooms, setRoomToEdit, setShow,placeId }: { rooms: any, setShow: any, setRoomToEdit: any,placeId:any }) => {
    const [selectedRoomId, setSelectedRoomId] = useState<number | null>(null);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const dispatch = useDispatch<AppDispatch>();
    
        const userId = Cookies.get('userId');
    const { t } = useTranslation();

    const handleDeleteRoom = async () => {
        if (selectedRoomId !== null) {
            await dispatch(deleteRoom(selectedRoomId));
            setSelectedRoomId(null);
            userId && dispatch(fetchRoomsByStays({ stayId: placeId, userId }))
        }
    };

    const confirmDelete = (id: number) => {
        setSelectedRoomId(id);
        setDeleteModalOpen(true);
    };

    return (
        <div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {rooms.map((room: any) => (
                    <div
                        key={room.id}
                        className="bg-white shadow-md rounded-xl border border-gray-200 overflow-hidden flex flex-col"
                    >
                        {/* Room Image */}
                        <div className="w-full h-40 bg-gray-100">
                            {room.image ? (
                                <img
                                    src={room.image}
                                    alt="Room"
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <div className="w-full h-full flex items-center justify-center text-gray-400">
                                    {t("no-image")}
                                </div>
                            )}
                        </div>

                        {/* Room Info */}
                        <div className="p-4 flex-1 flex flex-col justify-between">
                            <div className="space-y-1">
                                <div className="text-sm text-gray-600">
                                    <span className="font-medium">{t("room-number")}:</span> {room.roomNumber}
                                </div>
                                <div className="text-sm text-gray-600">
                                    <span className="font-medium">{t("room-type")}:</span> {room.type}
                                </div>
                                <div className="text-sm flex gap-1 text-gray-600">
                                    <span className="font-medium">{t("price-per-night")}:</span>{" "}
                                    {room.hasOffer ? (
                                        <span className=' flex gap-2'>
                                            <span className="line-through text-red-500 ">
                                                {room.pricePerNight} {room.currencyCode}
                                            </span>
                                            <span className="text-green-600 font-bold">
                                                {Math.round(room.pricePerNight * (1 - room.discount / 100))} {room.currencyCode }
                                            </span>
                                        </span>
                                    ) : (
                                        <span>
                                            {room.pricePerNight} {room.currencyCode}
                                        </span>
                                    )}
                                </div>
                            </div>

                            {/* Amenities */}
                            {room.amenities?.length > 0 && (
                                <div className="mt-4 flex flex-wrap gap-2">
                                    {room.amenities.map((amenity: any) => (
                                        <div
                                            key={amenity.id}
                                            title={amenity.title}
                                            className="w-6 h-6"
                                        >
                                            <img
                                                src={amenity.image}
                                                alt={amenity.title}
                                                className="w-full h-full object-contain rounded"
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* Actions */}
                            <div className="flex justify-between items-center gap-2 mt-4">
                                <button
                                    className="flex items-center gap-1 bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded text-xs"
                                    onClick={() => {
                                        setRoomToEdit(room);
                                        setShow(true);
                                    }}
                                >
                                    <FaEdit /> {t("edit")}
                                </button>
                                <button
                                    onClick={() => confirmDelete(room.id)}
                                    className="flex items-center gap-1 text-sm px-3 py-1 bg-red-100 text-red-600 hover:bg-red-200 rounded"
                                >
                                    <FaTrashAlt /> {t("delete")}
                                </button>
                            </div>
                        </div>
                    </div>
                ))}

                {/* Add new room */}
                <div
                    className="bg-white shadow-md rounded-xl p-6 border border-dashed border-gray-300 flex flex-col justify-center items-center text-gray-500 hover:border-gray-400 cursor-pointer"
                    onClick={() => setShow(true)}
                >
                    <span className="text-4xl">＋</span>
                    <span className="mt-2 text-sm font-medium">{t("add-new-room")}</span>
                </div>
            </div>

            <ConfirmDeleteModal
                isOpen={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={handleDeleteRoom}
                messageKey="delete-room-confirm"
            />
        </div>
    );
};

export default RoomList;
